import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core'
import { EditableNumericInput } from '../../common/EditableComponents'

import { getLinkIcon, MASTER_PRODUCT } from '../CommonUpdateCells'

export const MCTextComponent = (props) => {
  const { value, data } = props
  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = !data.masterId
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(MASTER_PRODUCT, isParent, data, props.colDef.field)

  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  return (
    <div className="center-item-column text-left text-truncate">
      <div
        className="align-item-column-value"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
        title={value}
      >
        {Array.isArray(value) ? value.join(', ') : value}
      </div>

      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export class MCTextEditor extends Component {
  state = { value: this.props.value }

  handleChange = (event) => {
    const value = event.target.value
    this.setState({ value })
  }
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const { value } = this.state

    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableNumericInput
            editMode={true}
            material={false}
            value={value}
            onChange={(event) => this.handleChange(event)}
            valueToRender={value}
          />
        </div>
      </div>
    )
  }
}

export default {
  MCTextComponent,
  MCTextEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCTextComponent.js